// src/pages/ItemAdjustment/components/ItemAdjustmentItemsTable.jsx
import React from "react";
import { Table, Button, Select, App, Grid } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  setItemsList,
  addAdjustmentRow,
  deleteAdjustmentRow,
  updateRow,
} from "../itemAdjustmentSlice";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import InputNumberField from "../../../components/Input/InputNumber";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { fetchBatchSerials } from "../itemAdjustmentThunk";
import { accessChecker } from "../../../lib/functions";

const { useBreakpoint } = Grid;

const ItemAdjustmentItemsTable = ({ itemsList, onSelectItem }) => {
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const batches = useSelector((s) => s.itemAdjustment.batches);
  const serials = useSelector(
    s => s.itemAdjustment.serials
  );
  const stock = useSelector((s) => s.itemAdjustment.stock);
  const lookups = useSelector((state) => state.lookups);
  const { modal } = App.useApp();
  const authInfo = useSelector(selectAuthInfo);
  const isTatmeenProduct = useSelector((s) => s.itemAdjustment.isTatmeenProduct);

  const isTatmeenEnabled = authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");

  const handleUpdate = (key, field, value) => {

    const updates = {
      [field]: value,
      total:
        field === "quantity" || field === "rate"
          ? Number(
            ((field === "quantity"
              ? value
              : itemsList.find((i) => i.key === key)?.quantity) || 0) *
            ((field === "rate"
              ? value
              : itemsList.find((i) => i.key === key)?.rate) || 0)
          )
          : undefined,
    };

    // ✅ Auto-set adjustment_type to damage when Tatmeen is enabled
    if (isTatmeenProduct) {
      updates.adjustment_type = "damage_stock";
    }

    dispatch(
      updateRow({
        key,
        data: updates,
      })
    );

    // dispatch(
    //   updateRow({
    //     key,
    //     data: {
    //       [field]: value,
    //       total:
    //         field === "quantity" || field === "rate"
    //           ? Number(
    //             ((field === "quantity"
    //               ? value
    //               : itemsList.find((i) => i.key === key)?.quantity) || 0) *
    //             ((field === "rate"
    //               ? value
    //               : itemsList.find((i) => i.key === key)?.rate) || 0)
    //           )
    //           : undefined,
    //     },
    //   })
    // );
    // dispatch(
    //   setItemsList(
    //     itemsList.map((r) =>
    //       r.key === key
    //         ? {
    //           ...r,
    //           [field]: value,
    //           total: Number(
    //             ((Number(r.quantity) || 0) * (Number(r.rate) || 0)).toFixed(2)
    //           ),
    //         }
    //         : r
    //     )
    //   )
    // );
  };

  const columns = [
    {
      title: "Item Name",
      dataIndex: "product",
      render: (_, record) => (
        <SearchListAutoComplete
          entityType="item"
          optionsList={lookups.items
            .filter((i) => i.is_service !== 'yes')
            .map((i) => ({
              sale_id: i.item_id,
              display_text: i.item_name,
              rate: i.sale_rate,
            }))
          }
          placeholder="Item"

          value={
            record.item_id
              ? {
                sale_id: record.item_id,
                display_text: record.product,
              }
              : null
          }


          onSelect={(obj) => {
            if (!obj) {
              // Clear the row properly
              handleUpdate(record.key, "item_id", null);
              handleUpdate(record.key, "product", "");
              return;
            }
            // ✅ Check if this item already exists
            const exists = itemsList.some(
              (r) => r.item_id === obj.sale_id && r.key !== record.key
            );

            if (exists) {
              // Show a warning
              window.alert("This item is already added!");
              return;
            }

            // ✅ If not duplicate, update row with product + rate
            onSelectItem(obj, record.key);
          }}
        />
      ),
    },
    // {
    //   title: "Batch",
    //   dataIndex: "batch_id",
    //   width: 150,
    //   render: (_, record) => (
    //     <Select
    //       style={{ width: "100%" }}
    //       value={record.batch_id || undefined}
    //       placeholder="Select batch"
    //       onChange={(val) => {
    //         const stockInfo = stock[record.item_id];

    //         // Batch cleared
    //         if (!val) {
    //           handleUpdate(record.key, "batch_id", null);
    //           handleUpdate(record.key, "batch_name", "");
    //           handleUpdate(record.key, "serial_mode", "unit");

    //           // ✅ When no batch selected, available_qty = loose_qty
    //           handleUpdate(
    //             record.key,
    //             "available_qty",
    //             stockInfo?.loose_qty || 0
    //           );

    //           // ✅ Reset quantity when batch is cleared
    //           handleUpdate(record.key, "quantity", 0);
    //           handleUpdate(record.key, "serials", []);
    //           return;
    //         }

    //         const batch = (batches[record.item_id] || []).find(
    //           (b) => b.id === val
    //         );

    //         if (!batch) return;

    //         handleUpdate(record.key, "batch_id", batch.id);
    //         handleUpdate(record.key, "batch_name", batch.batch_name);

    //         // ✅ Set available_qty based on serial_mode
    //         // Scenario 2 & 3: available_qty = batch.quantity
    //         handleUpdate(record.key, "available_qty", Number(batch.quantity));
    //         handleUpdate(record.key, "rate", batch.rate || record.rate);
    //         handleUpdate(record.key, "serial_mode", batch.serial_mode || "unit");
    //         handleUpdate(record.key, "serials", []);

    //         // Load serials only for Tatmeen + Unit serial mode
    //         if (isTatmeenEnabled) {
    //           dispatch(
    //             fetchBatchSerials({
    //               itemId: record.item_id,
    //               batchId: batch.id,
    //             })
    //           );
    //         }

    //         // ✅ Tatmeen Batch Mode - auto-fill and disable
    //         if (isTatmeenEnabled && batch.serial_mode === "batch") {
    //           handleUpdate(record.key, "quantity", Number(batch.quantity));
    //         } else {
    //           handleUpdate(record.key, "quantity", 0);
    //         }
    //       }}
    //       options={(batches[record.item_id] || []).map((b) => ({
    //         value: b.id,
    //         label: `${b.batch_name} (Avail: ${b.quantity})`,
    //       }))}
    //     />
    //   ),
    // },
    // src/pages/ItemAdjustment/components/ItemAdjustmentItemsTable.jsx

    ...(authInfo?.enable_batch_number !== "no"
      ? [
        {
          title: "Batch",
          dataIndex: "batch_id",
          width: 150,
          render: (_, record) => {
            const batchOptions = (batches[record.item_id] || []).map((b) => ({
              value: b.id,
              label: `${b.batch_name} (Avail: ${b.quantity})`,
            }));

            // ✅ Find the selected batch
            const selectedBatch = (batches[record.item_id] || []).find(
              (b) => b.id === record.batch_id
            );

            // ✅ If we have a batch_name from the row, use it for display
            const displayValue = record.batch_id || undefined;

            return (
              <Select
                style={{ width: "100%" }}
                value={displayValue}
                placeholder="Select batch"
                loading={!batches[record.item_id] && record.item_id}
                onChange={(val) => {
                  const stockInfo = stock[record.item_id];

                  if (!val) {
                    handleUpdate(record.key, "batch_id", null);
                    handleUpdate(record.key, "batch_name", "");
                    handleUpdate(record.key, "serial_mode", "unit");
                    handleUpdate(record.key, "available_qty", stockInfo?.loose_qty || 0);
                    handleUpdate(record.key, "quantity", 0);
                    handleUpdate(record.key, "serials", []);
                    return;
                  }

                  const batch = (batches[record.item_id] || []).find(
                    (b) => b.id === val
                  );

                  if (!batch) return;

                  handleUpdate(record.key, "batch_id", batch.id);
                  handleUpdate(record.key, "batch_name", batch.batch_name);
                  handleUpdate(record.key, "available_qty", Number(batch.quantity));
                  handleUpdate(record.key, "rate", batch.rate || record.rate);
                  handleUpdate(record.key, "serial_mode", batch.serial_mode || "unit");
                  handleUpdate(record.key, "serials", []);

                  if (isTatmeenEnabled && hasTatmeenEntryAccess) {
                    dispatch(
                      fetchBatchSerials({
                        itemId: record.item_id,
                        batchId: batch.id,
                      })
                    );
                  }

                  if (isTatmeenEnabled && hasTatmeenEntryAccess && batch.serial_mode === "batch") {
                    handleUpdate(record.key, "quantity", Number(batch.quantity));
                  } else {
                    handleUpdate(record.key, "quantity", 0);
                  }
                }}
                options={batchOptions}
                // ✅ Show the selected label properly
                optionLabelProp="label"
                notFoundContent={record.item_id ? "No batches available" : "Select item first"}
              />
            );
          },
        },
      ]
      : []),
    {
      title: "Avail. Qty",
      dataIndex: "available_qty",
      width: 120,
      render: (_, record) => <span>{record.available_qty || "-"}</span>,
    },
    {
      title: "Adjustment Type",
      dataIndex: "adjustment_type",
      width: 180,
      render: (_, record) => (
        <Select
          style={{ width: "100%" }}
          value={record.adjustment_type || "add_stock"}
          onChange={(val) => handleUpdate(record.key, "adjustment_type", val)}
          options={[
            { value: "add_stock", label: "Add" },
            { value: "damage_stock", label: "Damage" },
          ]}
        />
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 120,
      render: (_, record) => {
        // ✅ Determine if quantity field should be disabled
        const isDisabled =
          authInfo?.is_tatmeen_enabled &&
          record.serial_mode === "batch" &&
          record.adjustment_type === "damage_stock";

        // ✅ Get max allowed quantity based on rules
        const getMaxQty = () => {
          if (record.batch_id) {
            // Scenario 2 & 3: Batch selected
            return Number(record.available_qty || 0);
          } else {
            // Scenario 1: No batch selected
            return Number(record.loose_qty || 0);
          }
        };

        const maxQty = getMaxQty();

        return (
          <InputNumberField
            min={0}
            precision={1}
            step={0.5}
            disabled={isDisabled}
            value={record.quantity}
            placeholder="0"
            onClick={() => {
              if (isDisabled) {
                return;
              }
              if (record.quantity !== null && record.quantity !== 0) {
                handleUpdate(record.key, "quantity", null);
              }
            }}
            onChange={(v) => {
              // ✅ Scenario 3: Tatmeen Batch Mode - block changes
              if (isDisabled) {
                modal.warning({
                  title: "Batch Serial Mode",
                  content:
                    "Partial quantity adjustment is not allowed for Tatmeen Batch Mode.",
                });
                // Reset to batch quantity
                handleUpdate(record.key, "quantity", record.available_qty);
                return;
              }

              // ✅ Validate against max quantity
              const isMinusSale = authInfo.is_minus_stock_sale;

              // For damage stock, check availability
              if (
                record.adjustment_type === "damage_stock" &&
                v > maxQty &&
                !isMinusSale
              ) {
                modal.warning({
                  title: `Insufficient quantity of ${record.product}`,
                  content: (
                    <>
                      <p>
                        Available Quantity: <strong style={{ color: "red" }}>{maxQty}</strong>
                      </p>
                    </>
                  ),
                });
                return;
              }

              // ✅ For add_stock, allow any positive number (no max limit)
              if (record.adjustment_type === "add_stock") {
                // For add_stock, we just need to ensure it's not negative
                if (v < 0) {
                  modal.warning({
                    title: "Invalid Quantity",
                    content: "Quantity cannot be negative.",
                  });
                  return;
                }
              }

              handleUpdate(record.key, "quantity", v);
            }}
          />
        );
      },
    },
    {
      title: "Rate",
      dataIndex: "rate",
      width: 140,
      render: (_, record) => (
        <InputNumberField
          min={0}
          precision={2}
          step={0.5}
          value={record.rate}
          disabled
          onChange={(v) => handleUpdate(record.key, "rate", v)}
        />
      ),
    },
    {
      title: "Total",
      dataIndex: "total",
      width: 140,
      render: (_, record) => (
        <span>
          {Number((record.quantity || 0) * (record.rate || 0)).toFixed(2)}
        </span>
      ),
    },
    // In ItemAdjustmentItemsTable.jsx
    ...(isTatmeenEnabled && hasTatmeenEntryAccess
      ? [
        {
          title: "Serial Numbers",
          dataIndex: "serials",
          width: 300,
          render: (_, record) => {
            // ✅ Only show if batch is selected
            if (!record.batch_id) {
              return "-";
            }
            if (!authInfo?.is_tatmeen_enabled || !record.batch_id) {
              return "-";
            }
            const availableSerials = serials[record.batch_id] || [];
            const selectedSerials = record.serials || [];

            // ✅ For BATCH mode - single select (only one serial per batch)
            if (record.serial_mode === "batch") {
              if (availableSerials.length === 0) {
                return <span style={{ color: '#999' }}>Loading serials...</span>;
              }

              return (
                <Select
                  style={{ width: "100%" }}
                  placeholder="Select Batch Serial"
                  value={selectedSerials.length > 0 ? selectedSerials[0] : undefined}
                  onChange={(value) => {
                    // Store as array with single value
                    handleUpdate(record.key, "serials", value ? [value] : []);
                  }}
                  options={availableSerials.map(serial => ({
                    value: serial,
                    label: serial,
                  }))}
                  allowClear
                  showSearch
                />
              );
            }

            // ✅ For UNIT mode - multi-select
            return (
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select Serials"
                value={selectedSerials}
                onChange={(value) => {
                  handleUpdate(record.key, "serials", value);
                }}
                options={availableSerials.map(serial => ({
                  value: serial,
                  label: serial,
                }))}
                optionFilterProp="label"
                showSearch
              />
            );
          },
        },
      ] : []),
    {
      title: "Actions",
      dataIndex: "actions",
      width: 100,
      render: (_, record) => (
        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => dispatch(deleteAdjustmentRow(record.key))}
        />
      ),
    },
  ];

  return (
    <div>
      <div className="item-adjustment-table-scroll">
        <Table
          dataSource={itemsList}
          columns={columns}
          pagination={false}
          rowKey="key"
          scroll={{ x: "max-content" }}
          size={screens.md ? "middle" : "small"}
        />
      </div>
      <Button
        icon={<PlusOutlined />}
        onClick={() => dispatch(addAdjustmentRow())}
        style={{ marginTop: 12 }}
      >
        Add Row
      </Button>
    </div>
  );
};

export default ItemAdjustmentItemsTable;
